import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0311e74e")

_pushScopeId("data-v-0311e74e")
const _hoisted_1 = {
  key: 0,
  class: "page"
}
const _hoisted_2 = { class: "headers" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "right" }, [
  /*#__PURE__*/_createVNode("div", { class: "header-title" }, "健康体检"),
  /*#__PURE__*/_createVNode("div", { class: "description" }, "定期检查 关注健康 预防先行")
], -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "title" }, "手机号", -1)
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "cell" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "title" }, "验证码", -1)
const _hoisted_11 = { class: "input-container" }
const _hoisted_12 = { class: "submit" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 登录 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_count_down = _resolveComponent("van-count-down")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_form = _resolveComponent("van-form")

  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("header", _hoisted_2, [
          _createVNode(_component_van_image, {
            class: "logo",
            src: require('@/assets/image/pingwei/logo.png')
          }, null, 8, ["src"]),
          _hoisted_3
        ]),
        _createVNode("section", _hoisted_4, [
          _createVNode(_component_van_form, {
            onSubmit: _ctx.login,
            ref: "form"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, [
                  _withDirectives(_createVNode("input", {
                    class: "input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loginInfo.phone = $event)),
                    inputmode: "numeric",
                    oninput: "value=value.replace(/[^\\d]/g,'')",
                    placeholder: "请输入手机号"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.loginInfo.phone,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.loginInfo.phone)
                    ? _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                        key: 0,
                        class: "code-btn",
                        color: "#FF7336",
                        disabled: _ctx.code.flag,
                        onClick: _ctx.getCode
                      }, {
                        default: _withId(() => [
                          (!_ctx.code.flag)
                            ? (_openBlock(), _createBlock("p", _hoisted_8, "发送验证码"))
                            : (_openBlock(), _createBlock(_component_van_count_down, {
                                key: 1,
                                style: {"color":"white"},
                                time: _ctx.code.time,
                                format: "ss s",
                                onFinish: _ctx.onFinish
                              }, null, 8, ["time", "onFinish"]))
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])), [
                        [_vShow, /^1[0-9]{10}$/.test(_ctx.loginInfo.phone)]
                      ])
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("div", _hoisted_11, [
                  _withDirectives(_createVNode("input", {
                    class: _ctx.loginInfo.code ? 'code' : 'input',
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.loginInfo.code = $event)),
                    inputmode: "numeric",
                    oninput: "value=value.replace(/[^\\d]/g,'')",
                    placeholder: "请输入验证码"
                  }, null, 2), [
                    [
                      _vModelText,
                      _ctx.loginInfo.code,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_van_button, {
                  block: "",
                  color: "#FF7336",
                  style: {"border-radius":"0.16rem","font-weight":"bold"},
                  type: "primary",
                  "native-type": "submit"
                }, {
                  default: _withId(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]))
    : _createCommentVNode("", true)
})